import { render, staticRenderFns } from "./TestModule.vue?vue&type=template&id=33c85fab&scoped=true&"
import script from "./TestModule.vue?vue&type=script&lang=js&"
export * from "./TestModule.vue?vue&type=script&lang=js&"
import style0 from "./TestModule.vue?vue&type=style&index=0&id=33c85fab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c85fab",
  null
  
)

export default component.exports